import { actions } from './patient/actions'
import { getters } from './patient/getters'
import { state } from './patient/state'
import { mutations } from './patient/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
